"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteAsset = exports.addAsset = exports.fetchAssetsIfNeeded = exports.DELETE_ASSET = exports.ADD_ASSET = exports.FETCH_ASSETS = void 0;
var utils_1 = require("../../utils");
exports.FETCH_ASSETS = (0, utils_1.networkActionTypes)("FETCH_ASSETS");
exports.ADD_ASSET = (0, utils_1.networkActionTypes)("ADD_ASSET");
exports.DELETE_ASSET = (0, utils_1.networkActionTypes)("DELETE_ASSET");
var fetchAssets = (0, utils_1.networkAction)(exports.FETCH_ASSETS, "/assets");
exports.fetchAssetsIfNeeded = (0, utils_1.makeIfNeededAction)(fetchAssets, "assets");
var _addAsset = (0, utils_1.networkAction)(exports.ADD_ASSET, "/assets", "POST");
var addAsset = function (body, accessToken) {
    return function (dispatch, getState) {
        var state = getState();
        if (state.assets.isFetching || state.assets.isAdding || state.assets.isUpdating || state.assets.isDeleting)
            return;
        return dispatch(_addAsset(body, {}, accessToken));
    };
};
exports.addAsset = addAsset;
var deleteAsset = function (assetID, accessToken) {
    return function (dispatch, getState) {
        var state = getState();
        if (state.assets.isFetching || state.assets.isAdding || state.assets.isUpdating || state.assets.isDeleting)
            return;
        return dispatch((0, utils_1.networkAction)(exports.DELETE_ASSET, "/assets/".concat(assetID), "DELETE")({}, { id: assetID }, accessToken));
    };
};
exports.deleteAsset = deleteAsset;
